@if( content ) {
<div class="flex-column"
     [style.height]="'100vh'">
    <ng-container *ifNotLoggedIn>
        <!-- content -->
        <div class="w-12 flex-grow overflow-auto center bg-col-51 z-10">
            <div class="pos-relative">
                <!-- image -->
                <df-image-wrapper>
                    <img class="z-1"
                         [dfImage]="content.image"
                         [ratio]="content.imageRatio">
                </df-image-wrapper>
                <!-- close icon -->
                <i class="icon-close cursor-pointer pos-absolute top-5 right-5 z-10"
                   [attr.aria-label]="'Close' | translate"
                   [style.font-size.px]="14"
                   modalClose></i>
            </div>
            <div class="wrap-s wrap-m p-l-22-x p-l-22-l p-r-22-x p-r-22-l">
                <p class="h4 p-t-8 p-l-7-s p-l-7-m p-r-7-s p-r-7-m"
                   *iCms="'title' of content"></p>

                <p class="p2 col-11 p-t-4 p-b-8 p-l-4-s p-l-4-m p-r-4-s p-r-4-m"
                   *iCms="'description' of content"></p>

                <!-- 1px line -->
                <div class="w-12 bg-col-12"
                     [style.height.px]="1"
                     [style.max-width.px]="client.isS || client.isM ? 285 : 342"></div>

                <login-form-content class="block m-t-5 m-b-16-x m-b-16-l"></login-form-content>
            </div>
        </div>
    </ng-container>

    <div class="wrap p-t-22"
         *ifLoggedIn>
        <p class="h3 p-t-10"
           *iCms="'loggedInTitle' of content"></p>
        <p class="p2 p-t"
           *iCms="'loggedInDescription' of content"></p>
        <action class="button w-12 m-t-10"
                (click)="close()">
            <span *iCms="'loggedInCtaLabel' of content"></span>
        </action>
    </div>

</div>
}